var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* global FormData */
import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import T from '../../app/Locale';
import Modal from '../../app2/Components/ComponentModal';
import Button from '../../app2/Components/ComponentButton';
import ComponentSelect from '../../app2/Components/ComponentSelect';
const ModalUpload = ({ id = null, closeModal, content, options = null }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        file: false,
        option: false,
        response: false
    });
    const [selectedOption, setSelectedOption] = useState(false);
    const fileRef = React.createRef();
    const onUpload = () => __awaiter(void 0, void 0, void 0, function* () {
        const file = fileRef.current.files[0];
        // if there are options and no option is selected then set error message.
        if (options && !selectedOption) {
            setErrorMessage(Object.assign(Object.assign({}, errorMessage), { option: T.translate('documents.upload.error.noOption') }));
            return;
        }
        if (!file) {
            setErrorMessage(Object.assign(Object.assign({}, errorMessage), { file: T.translate('documents.upload.error.fileempty') }));
            return;
        }
        // Set maximum file size to 20000kb.
        if (file.size && file.size / 1000 > 20000) {
            setErrorMessage(Object.assign(Object.assign({}, errorMessage), { file: T.translate('documents.upload.error.filesize') }));
            return;
        }
        // Make sure a PDF is supplied.
        if (file.type !== 'application/pdf' && file.type !== 'application/x-pdf') {
            setErrorMessage(Object.assign(Object.assign({}, errorMessage), { file: T.translate('documents.upload.error.filetype') }));
            return;
        }
        try {
            setIsLoading(true);
            const data = new FormData();
            data.append('file', file);
            data.append('documentType', selectedOption);
            const url = id ? `/my-documents/upload-file/${id}` : '/my-documents/create-document';
            yield axios.post(url, data);
            window.location.reload();
        }
        catch (error) {
            if (error.response.data) {
                setErrorMessage(Object.assign(Object.assign({}, errorMessage), { response: error.response.data }));
            }
            else {
                setErrorMessage(Object.assign(Object.assign({}, errorMessage), { response: T.translate('documents.upload.error.unknown') }));
            }
            setIsLoading(false);
        }
    });
    return (_jsxs(Modal, Object.assign({ closeModal: closeModal, isWide: true }, { children: [_jsx("h2", { children: T.translate('documents.upload.title') }), _jsx("p", { children: content }), options && (_jsx(ComponentSelect, { id: 'type-select', title: T.translate('documents.upload.selectorTitle'), options: options, onChange: (selected) => {
                    setSelectedOption(selected);
                } })), errorMessage.option && (_jsx("span", Object.assign({ className: 'form-error is-visible' }, { children: errorMessage.option }))), _jsx("p", { children: _jsx("strong", { children: T.translate('documents.upload.notice') }) }), _jsx("br", {}), _jsx("input", { ref: fileRef, type: 'file', id: 'file-upload', onChange: () => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { file: false })) }), errorMessage.file && (_jsx("span", Object.assign({ className: 'form-error is-visible' }, { children: errorMessage.file }))), errorMessage.response && (_jsx("span", Object.assign({ className: 'form-error is-visible' }, { children: errorMessage.response }))), _jsx("br", {}), _jsx("br", {}), _jsx(Button, { title: T.translate('documents.upload.button'), isLoading: isLoading, onClick: onUpload })] })));
};
ModalUpload.propTypes = {
    closeModal: PropTypes.func.isRequired,
    content: PropTypes.string,
    options: PropTypes.object,
    id: PropTypes.number
};
export default ModalUpload;
